import { render, staticRenderFns } from "./dashboard-status-tab.vue?vue&type=template&id=375d5b08"
import script from "./dashboard-status-tab.vue?vue&type=script&lang=js"
export * from "./dashboard-status-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports